import styled from 'styled-components';
import Typography from '../../../components/shared/typography/Typography';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.background};
  height: auto;
  padding: 48px 87px;
  margin-bottom: 64px;

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    padding: 10px;
    font-size: 12px;

    .title{
      text-align: center;
    }
  }

  .title{
    width: 100%;
  }

  gap: 32px;
`;

export const Banner = styled.img`
  width: 100%;
  height: 350px;
  align: center;
  object-fit: cover;
`;

export const Dot = styled.div`
  align-self: center;
  height: 4px;
  width: 4px;
  background-color: ${(props) => props.theme.colors.label};
  border-radius: 50%;
  margin: 0 12px;

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    margin: 0;
  }
`;

export const DateAndHour = styled.span`
  color: ${(props) => props.theme.colors.label};
  display: flex;

  ${(props) => props.theme?.mediaQuerie.maxWidth.sm}{
    font-size: 12px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 16px;
    
  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    margin: 10px;
  }
  `;
  
  export const Row = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: start;
  
    ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
      gap: 12px;
      flex-wrap: wrap;
      justify-content: center;
    }
  `;

export const SubscribeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-left: auto;

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    margin-left: 0;
    flex-direction: row;
    width: 100%;
  }
`;

export const ImgContainer = styled.div`
  min-width: 288px;
  max-width: 288px;
  min-height: 208px;
  max-height: 208px;
  display: flex;
  
  img {
    object-fit: cover;
    width: 100%;
  }
`;

export const PrimaryContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: start;
  gap: 24px;

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    flex-wrap: wrap;
    text-align: center;
    justify-content: center;
  }
`;

export const StyledTypography = styled(Typography)`
  &.title {
    @media screen and (max-width: 670px) {
      font-size: 20px !important;
      line-height: 30px !important;
    }
  }
`;